import {getEventBasesList} from './EventBasesService.methods';

export const EventBasesService = {
    GetList: getEventBasesList,
};
